import React from 'react';
import { Star, TrendingUp } from 'lucide-react';
import { useStore } from '../stores/appStore';
import { calculateAverageRating } from '../utils';

export const Testimonials: React.FC = () => {
  const { depoimentos } = useStore();
  const depoimentosAprovados = depoimentos.filter(d => d.aprovado);
  
  const avaliacoes = depoimentosAprovados.map(d => d.avaliacao);
  const mediaAvaliacoes = calculateAverageRating(avaliacoes);

  const renderStars = (rating: number) => {
    return Array.from({ length: 5 }, (_, i) => (
      <Star
        key={i}
        size={16}
        className={i < rating ? 'fill-yellow-400 text-yellow-400' : 'text-gray-300'}
      />
    ));
  };

  return (
    <section className="py-16 bg-white">
      <div className="container-custom">
        <div className="text-center mb-12">
          <h2 className="text-3xl lg:text-4xl font-bold text-gray-900 mb-4">
            O que nossos clientes dizem
          </h2>
          <div className="flex items-center justify-center space-x-2 mb-2">
            <div className="flex">
              {renderStars(Math.round(mediaAvaliacoes))}
            </div>
            <span className="text-2xl font-bold text-gray-900">{mediaAvaliacoes}</span>
          </div>
          <p className="text-gray-600">Avaliação média de nossos clientes</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {depoimentosAprovados.map((depoimento) => (
            <div key={depoimento.id} className="card p-6">
              <div className="flex items-center mb-4">
                <div className="w-12 h-12 bg-primary-100 rounded-full flex items-center justify-center mr-4">
                  <span className="text-primary-600 font-semibold text-lg">
                    {depoimento.nome.charAt(0).toUpperCase()}
                  </span>
                </div>
                <div>
                  <h4 className="font-semibold text-gray-900">{depoimento.nome}</h4>
                  <div className="flex items-center space-x-1">
                    {renderStars(depoimento.avaliacao)}
                  </div>
                </div>
              </div>
              
              <p className="text-gray-700 mb-4 italic">
                "{depoimento.comentario}"
              </p>
              
              <div className="flex items-center justify-between text-sm text-gray-500">
                <span>{depoimento.moto}</span>
                <span>{new Date(depoimento.data).toLocaleDateString('pt-BR')}</span>
              </div>
            </div>
          ))}
        </div>

        {depoimentosAprovados.length === 0 && (
          <div className="text-center py-12">
            <TrendingUp className="w-16 h-16 text-gray-300 mx-auto mb-4" />
            <h3 className="text-xl font-semibold text-gray-600 mb-2">
              Em breve depoimentos de clientes
            </h3>
            <p className="text-gray-500">
              Estamos aguardando os primeiros feedbacks dos nossos clientes satisfeitos.
            </p>
          </div>
        )}

        <div className="mt-12 text-center">
          <div className="bg-primary-50 rounded-xl p-8 max-w-2xl mx-auto">
            <h3 className="text-2xl font-bold text-gray-900 mb-4">
              Deixe seu depoimento
            </h3>
            <p className="text-gray-600 mb-6">
              Compartilhe sua experiência e ajude outros clientes a fazer a melhor escolha.
            </p>
            <button className="btn-primary">
              Enviar Depoimento
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};